import React from "react"
import Helmet from 'react-helmet';
import { graphql, Link } from 'gatsby'
import Layout from "../components/layout"
import PostLink from "../components/post-link"
import HeroHeader from "../components/heroHeader"

const IndexPage = ({
	data: {
		site,
		allMarkdownRemark: { edges }
	}
}) => {
	const Posts = edges
		.filter(edge => !!edge.node.frontmatter.date)
		.map(edge => <PostLink key={edge.node.id} post={edge.node} />)

	return (
		<Layout>
			<Helmet>
				<title>{site.siteMetadata.title}</title>
				<meta name="description" content={site.siteMetadata.description} />
			</Helmet>
			<HeroHeader />
			<h2 className="post-heading">Recent Posts</h2>
			<div className="grids">
				{Posts}
			</div>
			<Link to="/blog" className="button -primary">Read More</Link>
		</Layout>
	)
}

export default IndexPage
export const pageQuery = graphql`
	query indexPageQuery {
		site {
			siteMetadata {
				title
				description
			}
		}
		
		allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }, limit: 6) {
			edges {
				node {
					id
					excerpt(pruneLength: 250)
					frontmatter {
						date(formatString: "MMMM DD, YYYY")
						path
						title
						thumbnail
					}
				}
			}
		}
	}
`
